export const isProduction = () =>
{
    return import.meta.env.MODE == 'production';
}

export const isNotProduction = () =>
{
    return isProduction() == false;
}

export const isLocal = () =>
{
    return process.env.NODE_ENV == 'development';
}

export const isDevelopment = () =>
{
    return isLocal() || import.meta.env.MODE == 'dev';
}

export const isDemo = () =>
{
    return import.meta.env.MODE == 'demo';
}

export const isUAT = () =>
{
    return import.meta.env.MODE == 'uat';
}